import * as React from "react";
import { Card, Button ,Modal, Header, Icon, Pagination} from 'semantic-ui-react'
import { TagToCategoryAssignForm } from "./assignTagToCategoryForm";
import { db } from "../../firebase";

import _ from 'lodash'

interface InterfaceProps {
  tags?: any;
  categories?: any;
  onhandleTagAssigned?:any
  onTagDeleted?:any
 
}

export class TagList extends React.Component<InterfaceProps, {}> {
  constructor(props: any) {
    super(props);
    this.handleTagAssign = this.handleTagAssign.bind(this)

    this.state = {
        activePage: 1
    };

  }

  handleTagDelete(id){
    const { onTagDeleted }: any = this.props;
    db.doDeleteTag(id)
    .then(() => {
        onTagDeleted()
        console.log("Tag Deleted")
      })
      .catch(error => {
        console.log("error catched")
      }); 
  }

  handleTagAssign(){
      const { onhandleTagAssigned}: any = this.props;
      onhandleTagAssigned()
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage })
  }

  public render() {
    const { tags , categories}: any = this.props;
    const {activePage}: any = this.state;
    const filtredTagKeysArray = Object.keys(tags).filter(key => !tags[key].assigned)
    return (
      <div>
        <Header as='h2'>List of not assigned tags </Header>
          <Card.Group itemsPerRow={4}>
          {filtredTagKeysArray.slice((activePage - 1) * 12, (activePage * 12) ).map(key => {
            return (
            <Card key={key}>
              <Card.Content>
                <Card.Header>{tags[key].text}</Card.Header>
              </Card.Content>
              <Card.Content extra>
                <div className='ui two buttons'>
                    <Modal 
                      trigger={
                        <Button size="tiny" basic color='green'>
                          Assign
                        </Button>
                        }>
                        <Modal.Header>Assign new Tag</Modal.Header>
                        <Modal.Content>
                          <Header as='h4'>
                            To Approve this tag, you have to assign it to one or more categories  
                          </Header>
                          <TagToCategoryAssignForm onAssigned = {this.handleTagAssign} tag= {tags[key]} categories={categories} />
                        </Modal.Content> 
                    </Modal>
                    <Modal 
                      trigger={
                        <Button size="tiny" basic color='red'>
                          Delete
                        </Button>
                        }>
                        <Modal.Header>Delete Tag</Modal.Header>
                        <Modal.Content>
                          Are you sure you want to delete this tag?
                        </Modal.Content>
                        <Modal.Actions>
                              <Button  onClick={() => this.handleTagDelete(tags[key].id)} color='red' >
                                <Icon name='checkmark' /> Yes
                              </Button>
                        </Modal.Actions>
                    </Modal>
                </div>
              </Card.Content>
            </Card>)
            })
          }
         </Card.Group>
         <br />
          { !!filtredTagKeysArray && filtredTagKeysArray.length > 0 && <div style={{ textAlign:"center"}}>
            <Pagination  
            activePage={activePage}
            onPageChange={(e,{activePage}) => this.handlePaginationChange(e, {activePage})}
            totalPages={filtredTagKeysArray.length % 12 === 0 ? filtredTagKeysArray.length / 12 : Math.floor(filtredTagKeysArray.length / 12) + 1}
            />
         </div>
          }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/tags/tagsList.tsx